import axios, { AxiosResponse } from "axios";
import { IAddress } from "../models/address";
import { ApiSearchResponse } from "../models/common";
import { ISearchParams, searchParamsInit } from "../models/searchParams";

export const addAddress = async (dto: IAddress): Promise<AxiosResponse<IAddress>> => {
    return await axios.post("/docks/address", dto);
};

export const changeAddress = async (dto: IAddress): Promise<AxiosResponse<IAddress>> => {
    return await axios.patch("/docks/address", dto);
};

export const deleteAddress = async (id: string): Promise<AxiosResponse<string>> => {
    return await axios.delete(`/docks/address/${id}`);
};

export const deactivateAddress = async (id: string): Promise<AxiosResponse<IAddress>> => {
    return await axios.patch(`/docks/address/deactivate/${id}`);
};

export const getAddress = async (id: string): Promise<AxiosResponse<IAddress>> => {
    return await axios.get(`/docks/address/${id}`);
};

export const searchAddress = async (
    searchParams: ISearchParams = searchParamsInit,
): ApiSearchResponse<IAddress> => {
    return await axios.post("/docks/address/search", searchParams);
};

export const getOwningCompanies = async () => {
    return (await axios.get<string[]>("/docks/expense/owningCompanies")).data;
};
